<wf-dialog-content withoutPadding>
  <form
    class="wf-profile-details-dialog__content"
    [formGroup]="profileForm"
    [wfUnsavedFormChanges]="profileForm"
    #unsavedFormChanges="wfUnsavedFormChanges"
  >
    <div
      class="wf-profile-details-dialog__section wf-profile-details-dialog__account"
    >
      <div class="wf-profile-details-dialog__avatar-wrapper">
        <wf-avatar
          color="secondary"
          class="wf-profile-details-dialog__avatar"
          [src]="_user().avatar"
          [name]="_user()?.fullName"
          [wuiTooltip]="_user()?.login"
          [wuiTooltipTitle]="_user()?.fullName"
          wuiTooltipPosition="after"
          wuiTooltipShowDelay="0"
          (click)="openAvatarDialog($event)"
          (keydown.enter)="openAvatarDialog($event)"
          (keydown.space)="openAvatarDialog($event)"
          tabindex="0"
          role="button"
          style="cursor: pointer"
          [style.width]="'100px'"
          [style.height]="'100px'"
          [style.font-size]="'24px'"
        />

        <div class="wf-profile-details-dialog__avatar-camera">
          <wf-icon iconName="camera-01" />
        </div>
      </div>

      <div class="wf-profile-details-dialog__account-management">
        <div class="wf-profile-details-dialog__info">
          <strong>{{ _user().fullName || _user().login }}</strong>

          @if (_user().fullName) {
            <small>{{ _user().login }}</small>
          }
        </div>

        <button
          type="button"
          class="wf-profile-details-dialog__manage-account-button"
          wui-stroked-button
          (click)="goToAccountSettings()"
        >
          <wf-icon
            iconName="user-01"
            iconClass="small"
            textClass="wf-text-sm-medium"
            [text]="'PROFILE_DETAILS_DIALOG.ManageMyAccountAction' | translate"
          ></wf-icon>
        </button>
      </div>
    </div>

    <div
      class="wf-profile-details-dialog__section wf-profile-details-dialog__color-scheme"
    >
      <div class="wf-profile-details-dialog__header">
        <div class="title">
          {{ 'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Title' | translate }}
        </div>

        <div class="description">
          {{ 'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Description' | translate }}
        </div>
      </div>

      <div
        class="wf-profile-details-dialog__color-scheme-options"
        role="radiogroup"
        [attr.aria-label]="
          'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Title' | translate
        "
      >
        <div class="option">
          <div
            class="option__image"
            [class.option__image--selected]="
              profileForm.controls.colorMode.value === 'light'
            "
            (click)="setColorMode('light')"
            (keydown.enter)="setColorMode('light')"
            (keydown.space)="setColorMode('light')"
            role="radio"
            [attr.aria-checked]="
              profileForm.controls.colorMode.value === 'light'
            "
            [attr.aria-label]="
              'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Light' | translate
            "
            tabindex="0"
          >
            <img
              width="120"
              height="60"
              ngSrc="/assets/images/color-modes/light-mode.png"
              alt=""
            />
          </div>

          <div class="option__label wf-text-sm-medium">
            {{ 'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Light' | translate }}
          </div>
        </div>

        <div class="option">
          <div
            class="option__image"
            [class.option__image--selected]="
              profileForm.controls.colorMode.value === 'dark'
            "
            (click)="setColorMode('dark')"
            (keydown.enter)="setColorMode('dark')"
            (keydown.space)="setColorMode('dark')"
            role="radio"
            [attr.aria-checked]="
              profileForm.controls.colorMode.value === 'dark'
            "
            [attr.aria-label]="
              'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Dark' | translate
            "
            tabindex="0"
          >
            <img
              width="120"
              height="60"
              ngSrc="/assets/images/color-modes/dark-mode.png"
              alt=""
            />
          </div>

          <div class="option__label wf-text-sm-medium">
            {{ 'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Dark' | translate }}
          </div>
        </div>

        <div class="option">
          <div
            class="option__image"
            [class.option__image--selected]="
              profileForm.controls.colorMode.value === 'auto'
            "
            (click)="setColorMode('auto')"
            (keydown.enter)="setColorMode('auto')"
            (keydown.space)="setColorMode('auto')"
            role="radio"
            [attr.aria-checked]="
              profileForm.controls.colorMode.value === 'auto'
            "
            [attr.aria-label]="
              'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Auto' | translate
            "
            tabindex="0"
          >
            <img
              width="120"
              height="60"
              ngSrc="/assets/images/color-modes/auto-mode.png"
              alt=""
            />
          </div>

          <div class="option__label wf-text-sm-medium">
            {{ 'PROFILE_DETAILS_DIALOG.COLOR_SCHEME.Auto' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="wf-profile-details-dialog__section wf-profile-details-dialog__language"
    >
      <div class="wf-profile-details-dialog__header">
        <div class="title">
          {{ 'PROFILE_DETAILS_DIALOG.LANGUAGE.Title' | translate }}
        </div>

        <div class="description">
          {{ 'PROFILE_DETAILS_DIALOG.LANGUAGE.Description' | translate }}
        </div>
      </div>

      <div class="wf-profile-details-dialog__language-options">
        <wf-input-select
          withoutNullable
          formControlName="language"
          [label]="'PROFILE_DETAILS_DIALOG.LANGUAGE.AppLanguage' | translate"
          [error]="
            profileForm.controls.language.touched &&
            (profileForm.controls.language.errors | errorMessage)
          "
          [options]="languageOptions()"
        >
        </wf-input-select>
      </div>
    </div>
  </form>
</wf-dialog-content>

<wf-dialog-actions>
  <button
    wui-stroked-button
    size="md"
    [disabled]="!unsavedFormChanges.hasChanges()"
    (click)="unsavedFormChanges.discard()"
  >
    {{ 'CancelChanges' | translate }}
  </button>

  <button
    wui-fill-button
    color="primary"
    size="md"
    [disabled]="profileForm.invalid || !unsavedFormChanges.hasChanges()"
    (click)="saveChanges()"
  >
    {{ 'Save' | translate }}
  </button>
</wf-dialog-actions>
